import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTelegram } from "../../context/TelegramContext";

const TelegramBackButton = () => {
  const tg = useTelegram();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!tg || !tg.BackButton) return;

    const hidePaths = [
      "/",
      "/achievement",
      "/mood-streak",
      "/recap",
      "/ai-analysis",
      "/statistics",
    ];

    if (hidePaths.includes(location.pathname)) {
      tg.BackButton.hide();
    } else {
      tg.BackButton.show();
    }

    const handleBack = () => {
      // 0. ПРІОРИТЕТ: Блокування глобальної навігації для локальних станів (AI Аналіз)
      // Якщо компонент сказав "я сам оброблю клік", ми зупиняємо глобальний обробник
      if (window.isInnerViewOpen) {
        return;
      }

      // 1. СПЕЦІАЛЬНА ПОВЕДІНКА ДЛЯ ТЕСТІВ
      if (location.pathname.startsWith("/test/")) {
        window.dispatchEvent(new Event("request-test-exit"));
        return; 
      }

      // 2. СПЕЦІАЛЬНА ПОВЕДІНКА ДЛЯ MOOD-MENU
      if (location.pathname === "/mood-menu") {
        localStorage.removeItem("selectedMood");
        localStorage.removeItem("selectedAdditionalMood");
        localStorage.removeItem("moodNote");
        localStorage.removeItem("selectedActivities");
        navigate("/");
        return;
      }

      // 3. СТАНДАРТНА ПОВЕДІНКА ДЛЯ ВСІХ ІНШИХ СТОРІНОК
      navigate(-1);
    };

    tg.BackButton.onClick(handleBack);

    return () => {
      tg.BackButton.offClick(handleBack);
    };
  }, [tg, location.pathname, navigate]);

  return null;
};

export default TelegramBackButton;